import { initAll, setGroup, setUserId } from '@amplitude/unified'
import { Environment, getEnvironment } from '@backoffice-frontend/environment'
import { useEffect } from 'react'

const AMPLITUDE_API_KEY = 'c7550f5d69449204fd58db0469a8cb75'

let initialized = false

export const initAnalytics = () => {
  if (initialized) return
  initialized = true

  if (getEnvironment() !== Environment.production) return
  if (window.location.hostname === 'localhost') return

  initAll(AMPLITUDE_API_KEY, {
    serverZone: 'EU',
    analytics: {
      autocapture: true,
    },
  })
}

export const identifyAnalyticsUser = (userId: string, organization: string) => {
  setUserId(userId)
  setGroup('organization', organization)
}

// These functions are called throughout the codebase from a previous GA4 integration.
// They are kept as no-ops while we explore Amplitude's autocapture as a replacement
// for custom events. We may revisit and wire these up to Amplitude later.

type TrackingProps = {
  action?: string
  category?: string
  label?: string
  value?: number
}

export const trackAnalyticsEvent = (_props: TrackingProps) => {}

export const trackClickEvent = (_label: string) => {}

export const useImpressionTracking = (
  _props: Omit<TrackingProps, 'action'>,
) => {
  useEffect(() => {}, [])
}
